import { api } from '@/shared'
import { message } from 'antd'
import { requirementLaborResourcesActions } from '@/entity/requirementLaborResources/index'

export const getData = () => {
	return async (dispatch) => {
		try {
			dispatch(requirementLaborResourcesActions.getDataAction())

			const res = await api.requirementLaborResources.getData()

			dispatch(requirementLaborResourcesActions.getDataActionDone(res))
		} catch (error){
			message.error(error.response?.data?.message)

			dispatch(requirementLaborResourcesActions.getDataActionFail())
		}
	}
}


export const getCalculator = (payload) => {
	const {data} = payload
	return async (dispatch) => {
		try {
			dispatch(requirementLaborResourcesActions.getCalculatorAction(data?.payload?.type))

			const res = await api.requirementLaborResources.getCalc(data)

			let body = {[data?.payload?.type]: res}

			dispatch(requirementLaborResourcesActions.getCalculatorActionDone(body))
		} catch (error){
			message.error(error.response?.data?.message)

			dispatch(requirementLaborResourcesActions.getCalculatorActionFail())
		}
	}
}

export const getCropRegion = (payload) => {
	const {data, onSuccess} = payload
	return async (dispatch) => {
		try {
			dispatch(requirementLaborResourcesActions.getCropRegionAction(data))
			dispatch(requirementLaborResourcesActions.getCropRaiActionDone([]))

			const res = await api.requirementLaborResources.getCropRegion(data)
			dispatch(requirementLaborResourcesActions.getCropRegionActionDone(res))
			onSuccess(res)
		} catch (error){
			message.error(error.response?.data?.message)

			dispatch(requirementLaborResourcesActions.getCropRegionActionFail())
		}
	}
}

export const getCropRai = (payload) => {
	const {data, onSuccess, params} = payload
	return async (dispatch) => {
		try {
			dispatch(requirementLaborResourcesActions.getCropRaiAction(data))
			const res = await api.requirementLaborResources.getCropRai({data, params})
			dispatch(requirementLaborResourcesActions.getCropRaiActionDone(res))
			onSuccess(res)
		} catch (error){
			message.error(error.response?.data?.message)

			dispatch(requirementLaborResourcesActions.getCropRaiActionFail())
		}
	}
}